import { Col, Row } from "antd";
import { useLocation } from "react-router-dom";
import Header from "../../../atoms/Header";
import DashboardTemplate from "../../../templates/Dashboard";
import { NeedHelp } from "../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getCompanyFieldsById } from "./ducks/actions";
import TagsCard from "./Components/TagsCard";

export default function TagsCategories() {
  const [loading, setLoading] = useState(false);
  const url = useLocation();
  const dispatch = useAppDispatch();
  const companyId = url?.pathname.split("/")[3];
  const tagItems = useAppSelector((state) => state?.tags?.tagData);

  useEffect(() => {
    if (companyId) {
      const payload = {
        company_id: companyId,
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId]);

  return (
    <DashboardTemplate loading={loading || tagItems?.loader}>
      <Header
        breadcrumb={[
          { label: "Company settings", href: `/company-settings/${companyId}` },
          { label: "Tags & categories" },
        ]}
        title="Tags & categories"
        description="Organize various items in groups for quick search, reporting, and more."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />
      {tagItems?.data && (
        <Row gutter={[24, 40]}>
          <Col span={8}>
            <TagsCard
              changeColor={false}
              setLoading={setLoading}
              moduleName="EMPLOYEES"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("EMPLOYEES")
              )}
              title="Employees (rockstar at)"
              description="Indicate which job an employee performs best in."
            />
          </Col>

          <Col span={8}>
            <TagsCard
              changeColor
              setLoading={setLoading}
              moduleName="MATERIALS"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("MATERIALS")
              )}
              title="Materials"
              description="Group by any criteria like type, color, purpose."
            />
          </Col>

          <Col span={8}>
            <TagsCard
              changeColor
              setLoading={setLoading}
              moduleName="EQUIPMENT"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("EQUIPMENT")
              )}
              title="Equipment"
              description="Group by any criteria like type or purpose."
            />
          </Col>

          <Col span={8}>
            <TagsCard
              changeColor
              setLoading={setLoading}
              moduleName="CLIENTS"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("CLIENTS")
              )}
              title="Clients"
              description="Group by any criteria like importance, industry, revenue."
            />
          </Col>

          <Col span={8}>
            <TagsCard
              changeColor
              setLoading={setLoading}
              moduleName="PROPERTIES"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("PROPERTIES")
              )}
              title="Properties"
              description="Group by any criteria like size, importance, revenue."
            />
          </Col>

          <Col span={8}>
            <TagsCard
              changeColor
              setLoading={setLoading}
              moduleName="CREWS"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("CREWS")
              )}
              title="Crews"
              description="Group by any criteria like experience level or crew structure."
            />
          </Col>

          <Col span={8}>
            <TagsCard
              changeColor
              setLoading={setLoading}
              moduleName="SUBCONTRACTORS"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("SUBCONTRACTORS")
              )}
              title="Subcontractors"
              description="Group by any criteria like specialization."
            />
          </Col>

          <Col span={8}>
            <TagsCard
              changeColor
              setLoading={setLoading}
              moduleName="SERVICE"
              data={tagItems?.data?.filter((item: { module: string }) =>
                item?.module?.includes("SERVICE")
              )}
              title="Service"
              description="Group by any criteria like type or purpose."
            />
          </Col>
        </Row>
      )}
    </DashboardTemplate>
  );
}
